import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { formatPostal, japaneseBase, englishBase } from '../utils/address';
import { t, lang } from '../i18n';

// One result line for the Reverse Search and Browse pages: 〒code + address (in
// the browser's language) + a button that jumps to the Postal Code page
// pre-filled & auto-run.
const PostalResultRow = ({ entry }) => {
  const navigate = useNavigate();
  const code = entry.postal_code;
  const base = lang === 'ja' ? japaneseBase(entry) : englishBase(entry);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        px: 2,
        py: 1.5,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="body1">
          <Box component="span" sx={{ color: 'text.secondary', mr: 1 }}>
            〒{formatPostal(code)}
          </Box>
          {base}
        </Typography>
      </Box>
      <Button
        size="small"
        variant="outlined"
        color="secondary"
        endIcon={<ArrowForward />}
        onClick={() => navigate(`/?zip=${code}`)}
        sx={{ flexShrink: 0 }}
      >
        {t('zip search', '郵便番号検索')}
      </Button>
    </Box>
  );
};

export default PostalResultRow;
